<app-titlebar #titlebar>
</app-titlebar>
<div class="flex">
  @if(isGridTileVisible){
  <app-jkbbchart [stklgSrv]="stklgSrv" [stkmaSrv]="stkmaSrv" [stockSrv]="stockSrv" [stockno]="stockno">
  </app-jkbbchart>
  }


  <mat-tab-group #masterTabGroup class="jk-tab-group w-full" (selectedTabChange)="onMasterTabChange($event)">
    <mat-tab #myTabGrid label="條件設定">
      <mat-toolbar class="h-9">
        <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">
          <mat-icon fontIcon="search"></mat-icon>查詢
        </button>
        <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doGetPreFilter()">
          <mat-icon fontIcon="period"></mat-icon>取前次
        </button>
        <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doDelete2()">
          <mat-icon fontIcon="delete"></mat-icon>整批刪除
        </button>
      </mat-toolbar>
      <app-jkdaterange #stkle001 label="交易日期" [(valueA)]="filterOpt.rgDateA" [(valueB)]="filterOpt.rgDateB"
        [required]="true">
      </app-jkdaterange>
      <app-jkbtnedit #stkle003 label="股票代號" [required]="false" [value]="filterOpt.stockNo" maintable="STKMA" item="W01"
        [showClearButton]="true">
      </app-jkbtnedit>
      <div class="jk-grid-cols-2" style="width: 800px;">
        <app-jkmultiselect #stkle010Com maintable="JCKMG" item="W01" label="條件代號" valueExpr="MG002" displayExpr="MG003"
          [params]="['STKLE010']" [(values)]="stkle010">
        </app-jkmultiselect>
        <div>
          <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doSetDefine(0)">
            <mat-icon fontIcon="setup"></mat-icon> ⬅️條件設定只有自訂價格
          </button>
          <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doSetDefine(1)">
            <mat-icon fontIcon="setup"></mat-icon> ⬅️條件設定只有自動追蹤
          </button>
        </div>

      </div>

    </mat-tab>
    <mat-tab #myTabDetail label="詳細資料">

      <div class="border-2  border-red-500">
        <mat-toolbar>
          <button mat-flat-button (click)="doRefresh()">重新整理</button>
          <button class="btn" [class.btn-secondary]="true" (click)="toggleGridTile()">切換走勢圖</button>
        </mat-toolbar>
      </div>
      <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)" (doubleClick)="gridDoubleClick($event)"></app-jkgridwin>
    </mat-tab>
    <mat-tab #myMobileView label="手機模式">
      @for (data of itemList; track data) {
      <mat-list>
        <table>
          <tr>
            <td><label style="font-size: 16px;color: blue;width: 80px;">
                {{ data.LE006 }} ({{data.LE003}}) {{data.LE002}}
              </label>
            </td>
            <td>
              <app-jkswitch [(value)]="data.LE008" [switchedOnText]="'已讀'" [switchedOffText]="'未讀'"
                (valueChange)="doReadOk(data)"></app-jkswitch>
              <button class="dx-button-danger" location="after" text="刪除" (onClick)="delete(data)">
              </button>

            </td>
            <td>

            </td>
          </tr>
          <tr>
            <td colspan="3">
              <app-jktextarea [value]="data.LE007" [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400">

              </app-jktextarea>
            </td>
          </tr>
        </table>
      </mat-list>
      }
  </mat-tab>
  </mat-tab-group>

</div>
